import type {ReactNode} from 'react';
import classNames from 'classnames';

import isString from '@tinkoff/utils/is/string';

import {TypographySize, useTypography} from '../../../hooks/typography';

import styles from './attachment-card-text.module.css';

type Props = {
    textPrimary: ReactNode;
    textSecondary?: ReactNode;
    className?: string;
};

export const AttachmentCardText = ({textPrimary, textSecondary, className}: Props) => {
    const [textPrimaryCls, textSecondaryCls] = useTypography([
        {
            size: TypographySize.BodyL,
        },
        {
            size: TypographySize.BodyS,
        },
    ]);

    return (
        <div className={classNames(styles.text, className)}>
            {isString(textPrimary) ? (
                <span className={classNames(textPrimaryCls, styles.textPrimary)}>{textPrimary}</span>
            ) : (
                textPrimary
            )}
            {isString(textSecondary) ? (
                <span className={classNames(textSecondaryCls, styles.textSecondary)}>{textSecondary}</span>
            ) : (
                textSecondary
            )}
        </div>
    );
};
